import React from 'react'

const CostTable = ({ title, section, color }) => {
  let total = 0;
  return (
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td style={{ width: "70%", padding: "10px 8px", backgroundColor: color, color: "white" }}><div><strong>{title}</strong></div></td>
          <td style={{ width: "10%", textAlign: "center", backgroundColor: color, color: "white" }}><strong>Unit £</strong></td>
          <td style={{ width: "10%", textAlign: "center", backgroundColor: color, color: "white" }}><strong>Qty</strong></td>
          <td style={{ width: "10%", textAlign: "center", backgroundColor: color, color: "white" }}><strong>Cost £</strong></td>
        </tr>
        {section.map((row) => {
          if (row.title !== null && row.title !== "") {
            total = total + row.amount;
            return <tr key={row.id}>
              <td style={!row.description ? { padding: "13px 8px" } : { padding: "4px 8px" }}>
                <div><strong style={{ fontSize: "14px" }} >{row.title}</strong></div>
                <small style={{ fontSize: "11px" }}>{row.description}</small>
              </td>
              <td style={{ textAlign: "center" }}><small>{row.unit}</small></td>
              <td style={{ textAlign: "center" }}><small>{row.quantity}</small></td>
              <td style={{ textAlign: "center" }}><small>{row.amount}</small></td>
            </tr>
          }
          return <tr key={row.id}></tr>
        })}
      </tbody>
      <tfoot>
        <tr>
          <td style={{ padding: "8px", textAlign: "right" }} ><strong style={{ fontSize: "14px" }}>Total monthly cost</strong></td>
          <td style={{ textAlign: "center" }} colSpan={3}><strong style={{ fontSize: "14px" }}>£{total}</strong></td>
        </tr>
      </tfoot>
    </table>
  )
}

export default CostTable